import type { ReactElement } from "react";
import Link from "next/link";
import EventCard from "@olivahealth/oli-ui/src/organisms/EventCard";
import useTranslation from "../../../hooks/useTranslation";
import useSessionCard from "./useSessionCard";
import { useSessionCard_session$key as Fragment } from "./__generated__/useSessionCard_session.graphql";

interface Props {
  session: Fragment;
}

export default function SessionCard({
  session,
}: Readonly<Props>): ReactElement | null {
  const {
    data: {
      buttonLabel,
      sessionStatus,
      careType,
      eventDate,
      isAwaitingPayment,
      checkoutUrl,
      isSessionActive,
      pendingProgressCheckSurvey,
      professional,
      sessionId,
      timeRange,
      isCancelled,
      eventShortDate,
    },
    effects: { handleClickButton },
  } = useSessionCard(session);
  const { t } = useTranslation("employeeOneToOnePage", {
    keyPrefix: "yourSessions",
  });

  if (session == null) {
    return null;
  }
  return (
    <Link
      href={`/sessions/${sessionId}`}
      data-testid={`card-session-${sessionId}`}
    >
      <EventCard
        buttonLabel={buttonLabel}
        sessionStatus={sessionStatus}
        careType={careType}
        date={eventDate}
        shortDate={eventShortDate}
        isActive={isSessionActive}
        onClickButton={handleClickButton}
        awaitingPayment={
          isAwaitingPayment ? t("sessionCard.awaitingPayment") : null
        }
        pendingProgressCheckSurvey={
          pendingProgressCheckSurvey
            ? t("sessionCard.pendingProgressCheckSurvey")
            : null
        }
        professional={professional}
        timeRange={timeRange}
        isCancelled={isCancelled}
        checkoutUrl={checkoutUrl}
      />
    </Link>
  );
}
